/* eslint-disable jsx-a11y/no-autofocus */
import React, { useEffect, useState, useRef, useCallback } from "react";
import CommonResendOtpStatus from "./CommonResendOtpStatus";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {
  OTPMODE,
  SIGNINRESPONSES,
  OTPFOR,
  PASSWORDCHANGEMODE,
  VERIFICATIONTYPE,
  USERINFO,
  OTPSTATUS,
  GLOBALSETTINGS,
  SYSTEMSETTINGS,
  REGEX,
  ACCOUNTLOCKKIND,
  AccountLockKind,
} from "../../data/constants";
import { resolveAccountLockKind, getResetFlowLockMessage } from "../../utils/accountLockHelper";
import { USERSIGNUPMESSAGES, USERSIGNINMESSAGES } from "../../constants/messages";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { SignUpWithPasswordRef } from "../signup/SignUpWithPassword";
import CloseIcon from "@mui/icons-material/Close";
import useApi from "../../hooks/useApi";
import BackdropProgressBar from "../../components/ui/BackdropProgressBar";
import {
  Box,
  Button,
  TextField,
  Alert,
  IconButton,
  Snackbar,
  Slide,
  SlideProps,
} from "@mui/material";
import { useSettingValue } from "../../services/useSettingValue";
import {
  HrEmployeeOtpDto,
  UpdatePasswordDto,
  VerifySignInDto,
  OtpResponseDto,
} from "../../types/User";
import {
  createAndSendOtp,
  verifyOtp,
  updatePassword,
  verifyUserSignIn,
} from "../../services/userService";
import PasswordComponent from "./PasswordComponent";
import OtpInput from "../CommonComponent/CustomOTP";
interface ForgotPasswordProps {
  open: boolean;
  handleClose: () => void;
  otpSendTo: string;
  mode: string;
  onPasswordUpdateComplete: (response: boolean) => void;
  userInputValue: string;
  onIsSessionLocked: () => void;
}

export default function ForgotPassword({
  open,
  handleClose,
  otpSendTo,
  mode,
  onPasswordUpdateComplete,
  userInputValue,
  onIsSessionLocked,
}: ForgotPasswordProps) {
  const otpRef = useRef(null);
  const userInputTextFieldRef = useRef<HTMLInputElement>(null);
  const [userInput, setUserInput] = React.useState("");
  const [userInputError, setUserInputError] = useState(false);
  const [userInputErrorMessage, setUserInputErrorMessage] = useState("");
  const [step, setStep] = useState(1);
  const [inputOtp, setInputOtp] = React.useState("");
  const [password, setPassword] = React.useState("");
  const firstTextFieldRef = useRef<HTMLInputElement>(null);
  const childRef = useRef<SignUpWithPasswordRef>(null);
  const [userId, setUserId] = useState(0);
  const [userEmail, setUserEmail] = useState("");
  const [userPhone, setUserPhone] = useState("");
  const [contactType, setContactType] = useState("");
  const [userName, setUserName] = useState("");
  const [userFirstName, setUserFirstName] = useState("");
  const [userLastName, setUserLastName] = useState("");
  const [contactValue, setContactValue] = useState("");
  const [isSessionLocked, setIsSessionLocked] = React.useState(false);
  const [accountLockKind, setAccountLockKind] = React.useState<AccountLockKind>(
    ACCOUNTLOCKKIND.NONE,
  );
  const isAccountLocked = accountLockKind !== ACCOUNTLOCKKIND.NONE;
  const [reusePasswordError, setReusePasswordError] = useState<string | null>(null);
  const SlideUp = (props: SlideProps) => <Slide {...props} direction="up" />;
  const [otpStatus, setOtpStatus] = useState({
    isVisibleSendOtp: true,
    isOtpSent: false,
    timer: 30,
    isResendDisabled: true,
    otpErrorMessage: "",
    isVerified: false,
    otpSentTo: "",
  });
  const updateOtpStatusState = useCallback((newState: Partial<typeof otpStatus>) => {
    setOtpStatus((prevState) => ({
      ...prevState,
      ...newState,
    }));
  }, []);
  const { loading, executeApi } = useApi();
  const otpFieldLength =
    Number(useSettingValue(SYSTEMSETTINGS.OTP_FIELD_LENGTH)) ||
    GLOBALSETTINGS.DEFAULT_OTP_FIELD_LENGTH;
  useEffect(() => {
    setStep(1);
    if (mode === PASSWORDCHANGEMODE.SETUP_PASSWORD && userInputValue !== "") {
      setUserInput(userInputValue);
    } else {
      setUserInput("");
    }
    setInputOtp("");
    if (open) {
      setTimeout(() => {
        userInputTextFieldRef.current?.focus();
      }, 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  useEffect(() => {
    let countdown: ReturnType<typeof setTimeout>;
    if (otpStatus.timer > 0) {
      countdown = setTimeout(() => updateOtpStatusState({ timer: otpStatus.timer - 1 }), 1000);
    } else {
      updateOtpStatusState({ isResendDisabled: false });
    }
    return () => clearTimeout(countdown);
  }, [otpStatus.timer, updateOtpStatusState]);

  const handleUserNameChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setUserInput(event.target.value);
    if (event.target.value !== "") {
      setUserInputError(false);
      setUserInputErrorMessage("");
    }
  };
  const handleNextClick = () => {
    setIsSessionLocked(false);
    setAccountLockKind(ACCOUNTLOCKKIND.NONE);
    if (!validateInputs()) return false;
    onVerifyUserInput();
  };
  const onVerifyUserInput = async () => {
    const sessionValue = localStorage.getItem(USERINFO.SESSIONVALUE);
    const userSessionData: VerifySignInDto = {
      userInput: userInput,
      sessionValue: sessionValue,
      verificationType: VERIFICATIONTYPE.RESET_PASSWORD,
    };
    const userDetails = await executeApi<VerifySignInDto, VerifySignInDto>(
      verifyUserSignIn,
      userSessionData,
    );
    if (userDetails && userDetails.result === SIGNINRESPONSES.VALID_USER) {
      if (!userDetails.isPasswordChangeAllowed) {
        setUserInputError(true);
        setUserInputErrorMessage(userDetails.message);
        return false;
      }
      updateOtpStatusState({ isOtpSent: true });
      focusFirstTextField();
      updateOtpStatusState({ isVisibleSendOtp: false });
      if (firstTextFieldRef.current) {
        firstTextFieldRef.current.focus();
      }
      setUserId(userDetails.userId);
      setUserEmail(userDetails.cachedEmailAddress);
      setUserPhone(userDetails.cachedPhoneNumber);
      setUserName(userDetails.userName);
      setUserFirstName(userDetails.cachedFirstName);
      setUserLastName(userDetails.cachedLastName);
      GenerateAndSendOTP(
        userDetails.cachedEmailAddress,
        userDetails.userName,
        userDetails.cachedPhoneNumber,
      );
      return true;
    } else if (userDetails.result === SIGNINRESPONSES.INVALID_USER) {
      setUserInputError(true);
      setUserInputErrorMessage(USERSIGNINMESSAGES.USER_NOT_REGISTERED);
    } else if (userDetails.result === SIGNINRESPONSES.SESSION_LOCKED) {
      setIsSessionLocked(true);
    } else if (userDetails.result === SIGNINRESPONSES.ACCOUNT_LOCKED) {
      // A failed-attempt lockout is let through by the API for the RESET-PASSWORD verification
      // type (it comes back as "Valid User" above), so a lock reported here blocks the reset -
      // an admin lock must not be self-clearable.
      setAccountLockKind(resolveAccountLockKind(userDetails.isAdminLocked));
    } else if (userDetails.result === SIGNINRESPONSES.ACCOUNT_EXPIRED) {
      setUserInputError(true);
      setUserInputErrorMessage(USERSIGNINMESSAGES.ACCOUNT_EXPIRED_MESSAGE);
    } else if (userDetails.result === SIGNINRESPONSES.ALREADY_REGISTRED_WITH_PRIMARY_ACCOUNT) {
      setUserInputError(true);
      setUserInputErrorMessage(
        USERSIGNINMESSAGES.ALREADY_REGISTRED_WITH_PRIMARY_ACCOUNT_FORGOTPASSWORD,
      );
    }
  };
  const GenerateAndSendOTP = async (email: string, userName: string, phone: string) => {
    const empAndOtpData: HrEmployeeOtpDto = {
      emailAddress: email,
      userName: userName,
      phone: phone,
      otpSendTo: otpSendTo,
      otpFor: OTPFOR.RESETPASSWORD,
      sessionValue: localStorage.getItem(USERINFO.SESSIONVALUE),
      mode: OTPMODE.SEND,
    };
    const response = await executeApi<HrEmployeeOtpDto, OtpResponseDto>(
      createAndSendOtp,
      empAndOtpData,
    );
    if (response) {
      updateOtpStatusState({ isOtpSent: true, otpSentTo: response.otpSentTo });
      setContactType(response.otpSentTo === OTPMODE.EMAIL ? OTPMODE.EMAIL : OTPMODE.SMS);
      if (response.otpSentTo === OTPMODE.EMAIL) {
        setContactValue(obfuscateEmail(email));
      } else if (response.otpSentTo === OTPMODE.SMS) {
        setContactValue(obfuscatePhone(phone, 3));
      }
      startTimer();
      updateOtpStatusState({ isVisibleSendOtp: false });
      if (firstTextFieldRef.current) {
        firstTextFieldRef.current.focus();
      }
      setTimeout(() => {
        focusFirstTextField();
      }, 100);
      setStep(2);
    }
  };
  const handleVerifyOtp = async () => {
    if (!inputOtp) {
      updateOtpStatusState({ otpErrorMessage: USERSIGNUPMESSAGES.OTP_CODE_REQUIRED });
      focusFirstTextField();
    } else if (inputOtp.length < otpFieldLength) {
      updateOtpStatusState({
        otpErrorMessage: USERSIGNUPMESSAGES.OTP_CODE_6_DIGIT_NUMBER + " " + contactType,
      });
      focusFirstTextField();
    } else {
      const empAndOtpData: HrEmployeeOtpDto = {
        sessionValue: localStorage.getItem(USERINFO.SESSIONVALUE),
        verificationCode: inputOtp,
        mode: OTPMODE.VERIFY,
      };
      const response = await executeApi<HrEmployeeOtpDto, OtpResponseDto>(verifyOtp, empAndOtpData);
      if (response.result === OTPSTATUS.MATCHED) {
        setStep(3);
      } else if (response.result === OTPSTATUS.EXPIRED) {
        updateOtpStatusState({
          otpErrorMessage: USERSIGNUPMESSAGES.OTP_CODE_EXPIRED,
          isVerified: false,
        });
      } else if (response.result === SIGNINRESPONSES.SESSION_LOCKED) {
        setIsSessionLocked(true);
        setAccountLockKind(ACCOUNTLOCKKIND.NONE);
        onIsSessionLocked();
      } else {
        updateOtpStatusState({
          otpErrorMessage: USERSIGNUPMESSAGES.OTP_CODE_DOES_NOT_MATCH,
          isVerified: false,
        });
      }
    }
  };

  const handleResendOTP = async () => {
    updateOtpStatusState({ otpErrorMessage: "" });
    const empAndOtpData: HrEmployeeOtpDto = {
      emailAddress: userEmail,
      phone: userPhone,
      userName: userName,
      otpSendTo: otpSendTo,
      otpFor: OTPFOR.SIGNUP,
      sessionValue: localStorage.getItem(USERINFO.SESSIONVALUE),
      mode: OTPMODE.SEND,
    };
    const response = await executeApi<HrEmployeeOtpDto, OtpResponseDto>(
      createAndSendOtp,
      empAndOtpData,
    );
    if (response) {
      startTimer();
      clearOtp();
    }
  };
  const clearOtp = () => {
    setInputOtp("");
    otpRef.current?.clear();
    focusFirstTextField();
  };
  const startTimer = () => {
    updateOtpStatusState({ timer: 30, isResendDisabled: true });
  };

  const validateInputs = () => {
    let isValid = true;
    if (!userInput || userInput.trim() === "") {
      setUserInputError(true);
      setUserInputErrorMessage(USERSIGNINMESSAGES.USERINPUT_REQUIRED);
      if (userInputTextFieldRef.current) {
        userInputTextFieldRef.current.focus();
      }
      isValid = false;
    } else {
      if (!checkInputValid(userInput)) {
        setUserInputError(true);
        setUserInputErrorMessage(USERSIGNINMESSAGES.USERINPUT_INVALID);
        return false;
      }
      setUserInputError(false);
      setUserInputErrorMessage("");
    }
    focusOnEmptyField();
    return isValid;
  };
  const checkInputValid = (value: string) => {
    if (REGEX.EMAIL.test(value)) return true;
    if (REGEX.PHONE.test(value)) return true;
    if (REGEX.USERNAME.test(value)) return true;
    return false;
  };
  const focusOnEmptyField = () => {
    if (!userInput) {
      userInputTextFieldRef.current?.focus();
    }
  };
  const focusFirstTextField = () => {
    if (!otpRef.current?.isComplete()) {
      otpRef.current?.focusFirstEmpty();
      return;
    }
  };
  const handlePasswordChange = (newPassword: string) => {
    setPassword(newPassword);
  };
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleConfirmPasswordChange = () => {};
  const handleChangePassword = async () => {
    if (!handleChildComponentToValidatePassword()) return;
    const status = await onUpdatePassword();
    if (status === PASSWORDCHANGEMODE.CANNOT_REUSE_PASSWORD) {
      setReusePasswordError(USERSIGNINMESSAGES.NEW_PASSWORD_ALERT);
    } else {
      onPasswordUpdateComplete(true);
      handleClose();
    }
  };
  const handleChildComponentToValidatePassword = () => {
    if (childRef.current) {
      return childRef.current.childComponetCall();
    }
    return true;
  };
  const onUpdatePassword = async () => {
    const empAndOtpData: UpdatePasswordDto = {
      userId: userId,
      password: password,
    };
    return await executeApi<UpdatePasswordDto, string>(updatePassword, empAndOtpData);
  };
  const obfuscateEmail = (email) => {
    const [localPart, domain] = email.split("@");
    if (!localPart || !domain) return email;
    const obfuscatedLocal = localPart.slice(0, 3) + "****";
    const domainName = domain.split(".")[0];
    const domainExt = domain.split(".")[1];
    if (!domainName || !domainExt) return email;
    const obfuscatedDomain = domainName[0] + "****";
    return `${obfuscatedLocal}@${obfuscatedDomain}.${domainExt}`;
  };
  const obfuscatePhone = (phone, visibleDigits = 4, maskChar = "*") => {
    if (!phone) return "";

    const phoneStr = phone.toString();
    const maskedPart = maskChar.repeat(phoneStr.length - visibleDigits);
    const visiblePart = phoneStr.slice(-visibleDigits);

    return maskedPart + visiblePart;
  };
  const handleDialogClose = () => {
    setIsSessionLocked(false);
    setAccountLockKind(ACCOUNTLOCKKIND.NONE);
    handleClose();
  };

  const handleCustomOtpChange = (otp) => {
    setInputOtp(otp);
  };
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          handleDialogClose();
        }
      }}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
      PaperProps={{
        component: "form",
        onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
          event.preventDefault();
          handleClose();
        },
        sx: { backgroundImage: "none" },
      }}
    >
      <BackdropProgressBar loading={loading} />
      <DialogTitle className="dialogtitle-font-size">
        {PASSWORDCHANGEMODE.SET_NEW_PASSWORD_TITLE}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleDialogClose}
        className="dialog-close-button"
        disabled={isSessionLocked}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, width: "100%" }}>
        {step === 1 && (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src="/reset-password.gif"
                alt="description"
                style={{ width: "100px", height: "100px" }}
              />
            </div>
            <DialogContentText>Let us help you</DialogContentText>
            {isSessionLocked && (
              <Alert severity="error" sx={{ marginBottom: "10px" }} className="alert-alert">
                {USERSIGNINMESSAGES.SESSION_LOCKED_MESSAGE.replace(
                  "{Session_value}",
                  localStorage.getItem(USERINFO.SESSIONVALUE),
                )}
              </Alert>
            )}
            {isAccountLocked && (
              <Alert severity="error" sx={{ marginBottom: "10px" }} className="alert-alert">
                {getResetFlowLockMessage(accountLockKind)}
              </Alert>
            )}
            <Alert severity="success" icon={false} className="alert-success">
              {USERSIGNINMESSAGES.FORGOTPASSWORD_HEADER_TEXT}
            </Alert>
            <TextField
              error={userInputError}
              helperText={userInputErrorMessage}
              id="userInput"
              type="text"
              name="userInputDialog"
              label="Email or Phone or Username"
              autoFocus
              required
              autoComplete="new-password"
              fullWidth
              variant="outlined"
              color={userInputError ? "error" : "primary"}
              size="small"
              value={userInput}
              onChange={handleUserNameChange}
              inputRef={userInputTextFieldRef}
              inputProps={{
                autoComplete: "new-password",
                form: {
                  autoComplete: "off", // Prevents form-wide auto-complete
                },
              }}
              disabled={isSessionLocked}
            />
            <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
              <Button
                variant="contained"
                onClick={handleNextClick}
                endIcon={<ArrowForwardIcon />}
                sx={{ px: 3, borderRadius: 2 }}
                disabled={isSessionLocked}
              >
                Next
              </Button>
            </DialogActions>
          </>
        )}
        {step === 2 && (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={otpStatus.otpSentTo === OTPMODE.EMAIL ? "/otp-email.gif" : "/otp-mobile.gif"}
                alt="description"
                style={{ width: "100px", height: "100px" }}
              />
            </div>
            {isSessionLocked && (
              <Alert severity="error" sx={{ marginBottom: "10px" }} className="alert-alert">
                {USERSIGNINMESSAGES.SESSION_LOCKED_MESSAGE.replace(
                  "{Session_value}",
                  localStorage.getItem(USERINFO.SESSIONVALUE),
                )}
              </Alert>
            )}
            {isAccountLocked && (
              <Alert severity="error" sx={{ marginBottom: "10px" }} className="alert-alert">
                {getResetFlowLockMessage(accountLockKind)}
              </Alert>
            )}
            <Alert severity="error" icon={false} className="alert-border">
              We&apos;ve sent a verification code to your {contactType} -{" "}
              <span style={{ fontFamily: "monospace" }}>{contactValue}</span>
            </Alert>
            <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
              <Box
                display="flex"
                gap={2}
                sx={{
                  flexWrap: "wrap",
                  width: "100%",
                  maxWidth: {
                    xs: "100%",
                    sm: `${otpFieldLength * 63}px`,
                  },
                }}
              >
                <OtpInput length={otpFieldLength} onChange={handleCustomOtpChange} ref={otpRef} />
              </Box>
            </Box>
            <div className="div-align">
              <div>
                <CommonResendOtpStatus
                  otpErrorMessage={otpStatus.otpErrorMessage}
                  timer={otpStatus.timer}
                  isResendDisabled={otpStatus.isResendDisabled || isSessionLocked}
                  handleResendOTP={handleResendOTP}
                />
              </div>
            </div>
            <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
              <Button
                variant="contained"
                onClick={handleVerifyOtp}
                endIcon={<ArrowForwardIcon />}
                sx={{ px: 3, borderRadius: 2 }}
                disabled={isSessionLocked}
              >
                Verify
              </Button>
            </DialogActions>
          </>
        )}
        {step === 3 && (
          <>
            <div style={{ marginLeft: "70px", marginRight: "70px" }}>
              <PasswordComponent
                ref={childRef}
                onPasswordInputChange={handlePasswordChange}
                onConfirmPasswordInputChange={handleConfirmPasswordChange}
                userFirstName={userFirstName}
                userLastName={userLastName}
                userName={userName}
              ></PasswordComponent>
            </div>
            <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
              <Button
                variant="contained"
                onClick={handleChangePassword}
                sx={{ px: 3, borderRadius: 2 }}
              >
                {PASSWORDCHANGEMODE.SET_NEW_PASSWORD_TITLE}
              </Button>
            </DialogActions>
            <Snackbar
              open={!!reusePasswordError}
              autoHideDuration={5000}
              onClose={() => setReusePasswordError(null)}
              TransitionComponent={SlideUp}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <Alert severity="error" variant="filled" onClose={() => setReusePasswordError(null)}>
                {USERSIGNINMESSAGES.NEW_PASSWORD_ALERT}
              </Alert>
            </Snackbar>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
